var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_131_4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.15002,
    y: -3.14999,
    width: 30.3,
    height: 30.3,
    fill: "#FABD05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L27.15 27.15H-3.15002L12 12Z",
    fill: "#EA4336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.15 -3.14999L-3.15002 27.15V-3.14999H27.15Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.15002 27.15L12 12L-3.15002 -3.14999V27.15Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3583 10.5998C19.5172 11.2335 19.5172 12.7665 18.3583 13.4003L9.87949 18.0372C8.68769 18.689 7.17255 17.9052 7.17255 16.6369L7.17255 7.36308C7.17255 6.09481 8.68769 5.31105 9.87949 5.96283L18.3583 10.5998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_4",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE54B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAD26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.2449f8381aae5b21ffe9e29563d9ad94.svg";
export { ForwardRef as ReactComponent };